module.exports = __webpack_public_path__ + "img/4.c4319a6a.jpg";